import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import img from '../../image for geo project/false.png'
const Resubscribe = () => {
       const { t } = useTranslation();
 
        
       return (
           <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column", marginTop:"150px"}}>
               <img src={img} alt=""width={100} height={100}/>
               <div style={{marginTop:"50px",display:"flex",alignItems:"center",flexDirection:"column"}}>
                   <Typography variant="h3" sx={{fontFamily:"oswald,cairo",fontWeight:"bolder"}}>
                     {t('Resubscribe.mass1')}
               </Typography>
                <Typography variant="h4" sx={{fontFamily:"oswald,cairo",mt:"10px",color:"gray"}}>
                  {t('Resubscribe.mass2')} 
               </Typography>
                
               </div>
           </div>
       );
}

export default Resubscribe;
